import React, { useEffect, useState } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import DirectionPathButton from '../../components/widgets/directionPathButton';
import { get } from '../../services/back.service';

function ListService() {
  const [msgGet ,setMsgGet] = useState('');
  const [ServiceType,setServiceType] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getService()
  }, []);

  const getService = async()=>{
    const resService = await get('/peritaje/service/',{})
    if(resService.success){
      setServiceType(resService.data);
    }else{
      setMsgGet(resService.message)
    }       
  }

  const editButton = (row) => {
    const cPath = '/services/service/'+row.id;
    return (
      <DirectionPathButton path={cPath} variant="outline-primary" text="Editar" />
    )
  };

  return (
    <Base>
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <DirectionPathButton path='/services/service/0'  variant="primary" text="Crear Servicio" />
      <ListTables
        data={ServiceType}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListService;
